import React from "react";

const PayperiodLoader = () => {
    return (
        <table className="rty-table loading">
            <thead>
                <tr>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Payroll Date</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <>{
                    [...Array(10)].map((_, i) => (
                        <tr key={i}>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                        </tr>
                    ))
                }</>
            </tbody>
        </table>
    )
}

export default PayperiodLoader;